module.exports = __webpack_public_path__ + "static/media/iconSondageWhite.3d23b741.svg";